
webpack.register(
    'modules/history-experience-landing/history-experience-landing',
    function() {
        return import('modules/history-experience-landing/history-experience-landing');
    },
    true
);